const mEditionProductSalesLettersModalUndefined = {
  mEditionProductSalesLettersModalUndefined: {
    buttonPrimary: 'Entendido',

    messageUndefined: {
      first: 'La carta de venta que estás intentando ver aún no existe ya que nunca ha sido publicada.',
      second: 'Si ya publicaste esta carta de venta, por favor espera unos minutos hasta que la misma sea procesada y vuelve a intentarlo.'
    },

    title: 'Acción Deshabilitada'
  }
}

export default mEditionProductSalesLettersModalUndefined
